import { useState, useCallback, useEffect } from "react";
import { LogisticMovementService } from "../services/LogisticMovementService";

export const useHookLogisticMovement = () => {
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [params, setParams] = useState({
    keyword: "",
    type: "",
    item_id: "",
    page: 1,
    per_page: 10,
  });

  const getData = useCallback(async () => {
    setLoading(true);
    setError(null);

    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== "" && v !== null && v !== undefined)
    );

    try {
      const res = await LogisticMovementService.get({ params: cleanParams });
      const result = res?.data?.data ?? [];
      setData(Array.isArray(result) ? result : []);
      setMeta(res?.data?.meta ?? null);
    } catch (err) {
      console.error(err);
      setError(err?.response?.data || err);
    } finally {
      setLoading(false);
    }
  }, [params]);

  useEffect(() => {
    getData();
  }, [getData]);

  return {
    data,
    meta,
    loading,
    error,
    params,
    setParams,
    refreshData: getData,
  };
};